import React from 'react';
import {
  FDBox, FDPaper, FDSecondaryActionIconButton, FDStack,
} from '@facet-wealth/design';
import useMobileLayout from 'Hooks/useMobileLayout';
import {
  ThreadListHeader,
} from 'Views/Page/Content/Templates/MessagesPage/components/MessagesPageContent/components/ThreadsSection/components/ThreadListHeader';
import {
  ThreadList,
} from 'Views/Page/Content/Templates/MessagesPage/components/MessagesPageContent/components/ThreadsSection/components/ThreadList';
import {
  ThreadListPagination,
} from 'Views/Page/Content/Templates/MessagesPage/components/MessagesPageContent/components/ThreadsSection/components/ThreadList/components/ThreadListPagination';
import { buildUseStyles, useTheme } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { Box } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4';
import classNames from 'classnames';
import {
  useThreadSectionCollapseContext,
} from 'Views/Page/Content/Templates/MessagesPage/components/MessagesPageContent/components/ThreadsSection/ThreadCollapseContext';

const useStyles = buildUseStyles('ThreadsSection', (theme) => ({
  root: {
    maxWidth: theme.dimensions.md,
    width: '30%',
    transition: 'width 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
  },
  rootMobile: {
    width: '100%',
    maxWidth: 'unset',
  },
  collapse: {
    width: 49,
  },
  container: {
    height: '100%',
  },
  show: {
    opacity: 1,
    visibility: 'visible',
    // Fade in slowly
    transition: 'opacity 300ms ease-in 0ms',
  },
  hide: {
    height: 0,
    opacity: 0,
    visibility: 'hidden',
    overflow: 'hidden',
    // Fade out quickly and then make invisible with a height of 0 (can't animate display none)
    transition: 'opacity 150ms ease-out 0ms, height 0s 150ms, visibility 0s 150ms',
  },
  // FDBox doesn't support what I need here, overflow isn't working properly unfortunately
  stackWithHeight: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
}));

const ThreadsSection = () => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const isMobile = useMobileLayout();
  const { collapsed, setCollapsed } = useThreadSectionCollapseContext();

  return (
    <Box
      className={classNames(classes.root,
        {
          [classes.rootMobile]: isMobile,
          [classes.collapse]: collapsed,
        })}
    >
      <FDPaper appearance="elevated" rounded={!isMobile} height={'100%'} width={'100%'}>
        <Box className={classNames(classes.container,
          {
            [classes.hide]: collapsed,
            [classes.show]: !collapsed,
          })}
        >
          <FDBox paddingY={2} height={'100%'}>
            {/* The below Box should be an FDStack but FDStack doesn't take a
             height param which kills the overflow scroll for the children */}
            <Box className={classes.stackWithHeight}>
              <ThreadListHeader />
              <FDBox
                overflow={'auto'}
                paddingX={2}
                height={'100%'}
              >
                <FDStack direction={'column'}>
                  <ThreadList />
                </FDStack>
              </FDBox>
              <ThreadListPagination />
            </Box>
          </FDBox>
        </Box>
        <Box className={classNames(
          {
            [classes.hide]: !collapsed,
            [classes.show]: collapsed,
          },
        )}
        >
          <FDStack alignItems={'center'} justifyContent={'center'}>
            <FDSecondaryActionIconButton icon={'chevronRight'} onClick={() => setCollapsed(false)} />
          </FDStack>
        </Box>
      </FDPaper>
    </Box>
  );
};

ThreadsSection.defaultProps = {};

ThreadsSection.propTypes = {};

export { ThreadsSection };
